var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictureSampleGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 100,
    viewBox: "0 0 130 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9 66.36C59.4364 74.8199 51.23 75.93 44.12 75.93C28.04 75.93 15 65.2 15 49.12C15 33.04 28.04 20 44.12 20C60.2 20 73.24 33.04 73.24 49.12C73.24 55.98 70.87 61.86 66.9 66.36Z",
    fill: "#583BE2",
    stroke: "#FFEB38",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6006 80.77L44.1206 76.19L32.6406 80.77V71.09L44.1206 75.67L55.6006 71.09V80.77Z",
    fill: "#FFEB38",
    stroke: "#FFEB38",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.19 44.7C36.19 45.51 35.53 46.17 34.72 46.17C33.91 46.17 33.25 45.51 33.25 44.7C33.25 43.89 33.91 43.23 34.72 43.23C35.53 43.23 36.19 43.89 36.19 44.7Z",
    fill: "#FFEB38",
    stroke: "#FFEB38",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9791 44.7C54.9791 45.51 54.3191 46.17 53.5091 46.17C52.6991 46.17 52.0391 45.51 52.0391 44.7C52.0391 43.89 52.6991 43.23 53.5091 43.23C54.3191 43.23 54.9791 43.89 54.9791 44.7Z",
    fill: "#FFEB38",
    stroke: "#FFEB38",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8594 51.58C42.3694 53.06 45.8794 53.06 49.3894 51.58",
    stroke: "#FFEB38",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.148 37.1775C112.578 35.6075 110.027 35.6075 108.457 37.1775L95.7275 49.9075L91.8675 46.0475C90.2975 44.4775 87.7475 44.4775 86.1775 46.0475C84.6075 47.6175 84.6075 50.1675 86.1775 51.7375L92.7075 58.2675C93.5375 59.0975 94.6375 59.4775 95.7275 59.4275C96.8175 59.4775 97.9175 59.0975 98.7475 58.2675L114.148 42.8575C115.718 41.2875 115.718 38.7375 114.148 37.1675V37.1775Z",
    fill: "#FFEB38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureSampleGood);
export default __webpack_public_path__ + "static/media/picture_sample_good.521ffae3aaa1c631257ec4d98fef34c6.svg";
export { ForwardRef as ReactComponent };